/* Ledger — optional GSAP layer.
   Loaded during browser idle time, never render-blocking.
   Skipped for reduced-motion, small screens, and save-data connections. */
(function () {
  'use strict';

  var cfg = window.Ledger || {};
  if (!cfg.settings || !cfg.settings.gsap) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 990) return;
  if (navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''))) return;

  var GSAP = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var ST = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';

  function load(src) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = res;
      s.onerror = rej;
      document.head.appendChild(s);
    });
  }

  function idle(fn) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2600 });
    else setTimeout(fn, 1400);
  }

  function enhance() {
    var gsap = window.gsap;
    if (!gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(window.ScrollTrigger);

    /* Hero: staggered entrance + term-sheet parallax */
    var hero = document.querySelector('[data-gsap-hero]');
    if (hero) {
      var items = hero.querySelectorAll('[data-gsap-hero-item]');
      if (items.length) {
        gsap.set(items, { opacity: 0, y: 22 });
        gsap.to(items, {
          opacity: 1,
          y: 0,
          duration: 0.85,
          ease: 'power3.out',
          stagger: 0.08,
          delay: 0.05
        });
      }
      var panel = hero.querySelector('[data-gsap-parallax]');
      if (panel) {
        gsap.to(panel, {
          yPercent: -6,
          ease: 'none',
          scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 0.6 }
        });
      }
      var lines = hero.querySelector('.hero__grid-lines');
      if (lines) {
        gsap.to(lines, {
          yPercent: 8,
          ease: 'none',
          scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 1 }
        });
      }
    }

    /* Section headings: line-lift */
    gsap.utils.toArray('[data-gsap-lift]').forEach(function (el) {
      gsap.fromTo(el,
        { opacity: 0, y: 26 },
        {
          opacity: 1, y: 0, duration: 0.9, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 88%', once: true }
        }
      );
    });

    /* Card grids: stagger on enter */
    gsap.utils.toArray('[data-gsap-stagger]').forEach(function (group) {
      var kids = group.querySelectorAll(':scope > *');
      if (!kids.length) return;
      gsap.fromTo(kids,
        { opacity: 0, y: 30 },
        {
          opacity: 1, y: 0, duration: 0.75, ease: 'power3.out', stagger: 0.07,
          scrollTrigger: { trigger: group, start: 'top 86%', once: true }
        }
      );
    });

    /* CTA banner: glow drift */
    gsap.utils.toArray('.ctab__glow').forEach(function (glow) {
      gsap.to(glow, {
        xPercent: 6,
        yPercent: -4,
        ease: 'none',
        scrollTrigger: { trigger: glow.parentNode, start: 'top bottom', end: 'bottom top', scrub: 1.2 }
      });
    });

    /* Magnetic primary CTA in banners */
    document.querySelectorAll('.ctab .btn--primary').forEach(function (btn) {
      var qx = gsap.quickTo(btn, 'x', { duration: 0.4, ease: 'power3' });
      var qy = gsap.quickTo(btn, 'y', { duration: 0.4, ease: 'power3' });
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        qx((e.clientX - (r.left + r.width / 2)) * 0.18);
        qy((e.clientY - (r.top + r.height / 2)) * 0.28);
      });
      btn.addEventListener('mouseleave', function () { qx(0); qy(0); });
    });

    /* Hand reveal duties to GSAP so the CSS layer doesn't double-animate */
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });

    window.ScrollTrigger.refresh();
  }

  idle(function () {
    load(GSAP)
      .then(function () { return load(ST); })
      .then(enhance)
      .catch(function () { /* CSS reveals already handle the fallback */ });
  });
})();
